const initNavPopup = () => ({
    containers: [],
    init() {
        this.containers = this.$root.querySelectorAll('[x-ref="container"]');

        this.containers.forEach((container) => {
            const item = container.querySelector('[x-ref="item"]');
            const popup = container.querySelector('[x-ref="popup"]');

            if (!item || !popup) {
                return console.warn('Every nav popup container should have an item and a popup');
            }

            // Container events
            container.addEventListener('click', () => {
                this.openPopup(item, popup);
            });
            container.addEventListener('mouseenter', () => {
                this.openPopup(item, popup);
            });
            container.addEventListener('mouseleave', () => {
                this.closePopup(item, popup);
            });
            container.addEventListener('focusout', (e) => {
                if (!container.contains(e.relatedTarget)) {
                    this.closePopup(item, popup);
                }
            });

            // Item events
            item.addEventListener('focus', () => {
                this.openPopup(item, popup);
            });

            // Click outside container events
            document.addEventListener('click', (e) => {
                if (!container.contains(e.target)) {
                    this.closePopup(item, popup);
                }
            });
        });
    },
    openPopup: function (item, popup) {
        item.setAttribute('aria-expanded', 'true');
        popup.hidden = false;
    },
    closePopup: function (item, popup) {
        item.setAttribute('aria-expanded', 'false');
        popup.hidden = true;
    },
});

export { initNavPopup as default };
